import { TYPE_WRAPPER } from '../constants/type-wrapper.const.mjs';
/**
 * Create a lazy reference to a value.
 * This is typically used to signal to `@InjectAll` that a reference must
 * not be eagerly loaded, e.g. in the case of cyclic dependencies.
 */
export function Lazy(fn) {
    return {
        [TYPE_WRAPPER]: 0 /* TypeWrapperStamp.Generic */,
        lazyType: fn,
        /**
         * Because extractable type-wrappers are able to completely override the resolution process,
         * we need to ensure that we resolve the constrained identifier directly in the container.
         *
         * To do this, the previous constraint resolution method was modularized, with the core resolution
         * process extracted into a new method.  This lets us call it from type-wrappers.
         */
        extract: (container, constraints) => container.resolveConstrainedIdentifier(fn(), constraints),
    };
}
//# sourceMappingURL=lazy.function.mjs.map